export function pushDidomiConsent() {
  const event = {
    event: "didomi-consent",
    didomiPurposesEnabled: "cookies",
    didomiVendorsEnabled: "bonniernews",
  };
  window.dataLayer.push(event);
}

export function pushDidomiReady() {
  const event = { event: "didomi-ready" };
  window.dataLayer.push(event);
}

export function mockDidomi() {
  window.Didomi = { getCurrentUserStatus: () => ({ user_id: "88888888-8888-8888-8888-888888888888" }) };
}
